import { RADIUS } from "@/styles/common";
import { ModalBody, ModalContent } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomModalContent = styled(ModalContent)`
    width: auto;
    height: auto;
    padding: 0;
    ${RADIUS(4)}
    margin: 0 !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
`;

export const CustomModalBody = styled(ModalBody)`
    padding: 0;
`;
